
        var result = require("!!../../../../node_modules/css-loader/index.js!./management-customer-info.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/management/customer-info/management-customer-info.component.css
// module id = 2507
// module chunks = 1